export interface DnnToggleChangeEventDetail {
    checked: boolean;
}